/** Extract a trip email-invite id from a post-auth `next` path. */
export function parseEmailInviteIdFromNext(next: string | undefined): string | null {
  if (!next) return null;
  const safe = next.startsWith('/') && !next.startsWith('//') ? next : null;
  if (!safe) return null;
  const match = /^\/join\/email-invite\/([^/?#]+)/.exec(safe);
  return match?.[1] ?? null;
}
